import React, { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Blue_btn from "../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../common_components/common_btn/blue_border_button/Blue_border_button";
import CollageRegistration_step_1 from "./collageRegistration_step_1/CollageRegistration_step_1";
import CollageRegistration_step_2 from "./collageRegistration_step_2/CollageRegistration_step_2";
import CollageRegistration_step_3 from "./collageRegistration_step_3/CollageRegistration_step_3";
import CollageRegistration_step_4 from "./collageRegistration_step_4/CollageRegistration_step_4";
import CollageRegistration_step_5 from "./collageRegistration_step_5/CollageRegistration_step_5";
import { useDispatch, useSelector } from "react-redux";
import { useFieldArray, useForm, Watch } from "react-hook-form";

import {
  Create1,
  GetRegistration1,
  Create2,
  Create3,
  Create4,
  Create5,
} from "../../../features/admin/college_register/register/Slice";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

const CollageRegistration = () => {
  const [step, setStep] = useState(1);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { getUserData1 } = useSelector((state) => state);

  console.log(getUserData1, "getUserData1");

  //  MUST COME FIRST
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
    setError,
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      academic_info: [
        {
          school_selection: "",
          program_name: "",
          enrollment_status: "",
          education_level: "",
          academic_year: "",
          student_id_number: "",
        },
      ],
    },
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "academic_info",
  });

  //  Resume logic
  useEffect(() => {
    if (getUserData1) {
      Object.keys(getUserData1).forEach((key) => {
        if (key === "show_password") {
          //  map show_password to password field
          setValue("password", getUserData1.show_password);
        } else {
          setValue(key, getUserData1[key]);
        }
      });

      if (getUserData1.last_completed_step) {
        setStep(Math.min(getUserData1.last_completed_step + 1, 5));
      }
    }
  }, [getUserData1, setValue]);

  // Prefill Step 2
  const getUserData2 = useSelector(
    (state) => state.studentapplication.studentregistration.getUserData2,
  );

  console.log(getUserData2, "getUserData2");

  // Prefill Step 2
  useEffect(() => {
    if (getUserData2) {
      Object.keys(getUserData2).forEach((key) => {
        if (key === "college_type_id" && getUserData2.college_type_id) {
          setValue("college_type_id", {
            label: getUserData2.gender_name,
            value: getUserData2.college_type_id,
          });
        } else {
          setValue(key, getUserData2[key]);
        }
      });

      if (getUserData2.last_completed_step) {
        setStep(Math.min(getUserData2.last_completed_step + 1, 5));
      }
    }
  }, [getUserData2, setValue]);

  // Correct useSelector for step 3
  const getUserData3 = useSelector(
    (state) => state.studentapplication.studentregistration.getUserData3,
  );

  // Prefill Step 3
  useEffect(() => {
    if (getUserData3) {
      // Prefill all fields explicitly
      setValue("passport_number", getUserData3.passport_number || "");
      setValue(
        "passport_issue_country",
        getUserData3.passport_issue_country || "",
      );
      setValue(
        "passport_expiry_date",
        getUserData3.passport_expiry_date
          ? getUserData3.passport_expiry_date.split("T")[0]
          : "",
      );
      setValue("passport_address", getUserData3.passport_address || "");
      setValue(
        "passport_current_address",
        getUserData3.passport_current_address || "",
      );
      setValue("passport_contact_no", getUserData3.passport_contact_no || "");
      setValue("guardian_name", getUserData3.guardian_name || "");
      setValue("guardian_phone", getUserData3.guardian_phone || "");
      setValue("guardian_email", getUserData3.guardian_email || "");
      setValue("relation", getUserData3.relation || "");

      if (getUserData3.last_completed_step) {
        setStep(Math.min(getUserData3.last_completed_step + 1, 5));
      }
    }
  }, [getUserData3, setValue]);

  // Correct useSelector for step 4
  const getUserData4 = useSelector(
    (state) => state.studentapplication.studentregistration.getUserData4,
  );

  // Prefill Step 4
  useEffect(() => {
    if (getUserData4 && getUserData4.length) {
      replace(
        getUserData4.map((item) => ({
          id: item.id,
          school_selection: item.school_selection ?? "",
          program_name: item.program_name ?? "",

          enrollment_status: item.enrollment_status === true ? "1" : "0",

          education_level: item.education_level ?? "",
          academic_year: item.academic_year
            ? item.academic_year.split("T")[0]
            : "",
          student_id_number: item.student_id_number ?? "",
        })),
      );
    }
  }, [getUserData4, replace]);

  const getUserData5 = useSelector(
    (state) => state.studentapplication.studentregistration.getUserData5,
  );

  useEffect(() => {
    if (getUserData5) {
      Object.keys(getUserData5).forEach((key) => {
        setValue(key, getUserData5[key]);
      });
    }
  }, [getUserData5, setValue]);

  // Fetch Step 1 + Step 2 on reload
  useEffect(() => {
    const storedUserId = Cookies.get("college_user_id");
    if (storedUserId) {
      dispatch(GetRegistration1(storedUserId));
      // dispatch(GetRegistration2(storedUserId));
      // dispatch(GetRegistration3(storedUserId));
      // dispatch(GetRegistration4(storedUserId));
    }
  }, [dispatch]);

  //  Fetch step-1 data on reload
  useEffect(() => {
    const storedUserId = Cookies.get("college_user_id");
    if (storedUserId) {
      dispatch(GetRegistration1(storedUserId));
    }
  }, [dispatch]);

  //  MAIN SUBMIT HANDLER
  const onSubmit = async (data) => {
    console.log(data, "data");

    try {
      const userId = Cookies.get("college_user_id");

      //  Only block steps AFTER step 1
      if (step > 1 && !userId) {
        console.error("User not created yet. Complete Step 1.");
        return;
      }

      // ================= STEP 1 =================
      if (step === 1) {
        const formData = new FormData();
        const existingUserId = Cookies.get("college_user_id");

        if (existingUserId) {
          formData.append("user_id", existingUserId);
        }

        formData.append("name", data.name);
        formData.append("website_url", data.website_url);
        formData.append("email", data.email);
        formData.append("contact_no", data.contact_no);
        formData.append("password", data.password);
        formData.append("headquarter_address", data.headquarter_address);
        formData.append("role_id", data.role_id);

        try {
          const res = await dispatch(Create1(formData)).unwrap();
          const createdUserId = res?.data?.user_id;

          if (!existingUserId && createdUserId) {
            Cookies.set("college_user_id", createdUserId);
          }

          await dispatch(GetRegistration1(existingUserId || createdUserId));

          setStep(2);
          return;
        } catch (err) {
          // ------------------ Handle backend validation errors ------------------
          const backendMessage =
            err?.errors || err?.message || "Registration failed";

          if (backendMessage.toLowerCase().includes("email")) {
            setError("email", { type: "manual", message: backendMessage });
          } else if (backendMessage.toLowerCase().includes("contact")) {
            setError("contact_no", { type: "manual", message: backendMessage });
          } else {
            console.error("Unknown error:", backendMessage);
          }
          return;
        }
      }

      // ================= STEP 2 =================
      if (step === 2) {
        const formData = new FormData();
        formData.append("user_id", userId);
        formData.append(
          "college_type_id",
          data.college_type_id?.value || data.college_type_id,
        );
        formData.append("college_type", data.college_type || "");
        formData.append("acc_auth_name", data.acc_auth_name);
        formData.append("acc_val_period", data.acc_val_period);
        formData.append("reg_no", data.reg_no);
        formData.append("country", data.country);
        formData.append("state", data.state);
        formData.append("city", data.city);
        formData.append("pincode", data.pincode);
        formData.append("street", data.street);

        const res = await dispatch(Create2(formData));

        console.log(res, "res");

        if (res?.meta?.requestStatus == "fulfilled") {
          // fetch step 2 data to prefill
          await dispatch(GetRegistration1(userId));

          // move to step 3
          setStep(3);
        }
        return;
      }

      // ================= STEP 3 =================
      if (step === 3) {
        const formData = new FormData();
        formData.append("user_id", userId);
        formData.append("send_s_abroad", data.send_s_abroad);
        formData.append("abroad_off_contact", data.abroad_off_contact || "");
        formData.append("abroad_stu_quantity", data.abroad_stu_quantity || "");

        const res = await dispatch(Create3(formData));

        if (res?.meta?.requestStatus == "fulfilled") {
          // fetch step 3 data to prefill if needed
          await dispatch(GetRegistration1(userId));

          // move to step 4
          setStep(4);
        }
        return;
      }

      if (step === 4) {
        const formData = new FormData();
        formData.append("user_id", userId);
        formData.append("r_first_name", data.r_first_name);
        formData.append("r_last_name", data.r_last_name);
        formData.append("r_position", data.r_position);
        formData.append("r_email", data.r_email);
        formData.append("r_contact", data.r_contact);
        formData.append(
          "auth_to_sign_internship",
          data.auth_to_sign_internship,
        );

        const res = await dispatch(Create4(formData));

        if (res?.meta?.requestStatus == "fulfilled") {
          await dispatch(GetRegistration1(formData));
          setStep(5);
        }
      }

      // ================= STEP 5 =================
      if (step === 5) {
        const userId = Cookies.get("college_user_id");

        const payload = {
          user_id: userId,
          study_abroad_objective: data.study_abroad_objective,
          country: data.country,
          previous_international_experience: Number(
            data.previous_international_experience,
          ), // ✅ 1 or 0
        };

        const res = await dispatch(Create5(payload));

        if (res?.meta?.requestStatus == "fulfilled") {
          await dispatch(GetRegistration1(userId));

          // ✅ remove cookie
          Cookies.remove("college_user_id");

          // ✅ success popup for 2 seconds and auto redirect
          Swal.fire({
            icon: "success",
            title: "Registration Completed",
            text: "Your registration has been successfully completed.",
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false, // remove button
            didClose: () => {
              navigate("/"); // redirect after 2 seconds
            },
          });
        }

        return;
      }

      // ================= STEP 3–4 =================
      if (step < 5) {
        setStep(step + 1);
        return;
      }

      // ================= STEP 5 =================
      console.log("FINAL SUBMIT", data);
    } catch (error) {
      console.error("Form error:", error);
    }
  };

  return (
    <section className="HotelRegistration common_step_form_wrapper">
      <div className="login_form_div">
        <div className="login_card">
          <div className="hotel-form-card">
            <section className="login_wrapper">
              <div className={`login_div`}>
                <div className="row justify-content-center me-0 ms-0">
                  <div className="col-lg-6 col-md-11 order-2 order-lg-1 ">
                    <div className="left_content">
                      <h1 className="main_heading">
                        From recruitment to contracts All in One Place
                      </h1>

                      <p className="main_text">
                        Seamlessly apply, hire, & manage every step of the
                        internship process with confidence.
                      </p>

                      <div className="feature_box">
                        <h5 className="feature_heading">SEAMLESS PROCESS</h5>
                        <p className="feature_text">
                          Submit your documents online, get them reviewed, and
                          receive approvals faster
                        </p>
                      </div>

                      <div className="feature_box">
                        <h5 className="feature_heading">ALL IN ONE</h5>
                        <p className="feature_text">
                          Apply for internships, post offers, upload CDD
                          documents, and track your applications
                        </p>
                      </div>

                      <div className="feature_box">
                        <h5 className="feature_heading">
                          TRANSPARENT & RELIABLE
                        </h5>
                        <p className="feature_text">
                          Every step is verified by experts available 24/7 to
                          guide you
                        </p>
                      </div>

                      <h2 className="tagline">
                        We Nurture Talent Across The Globe
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-11 order-1 order-lg-2 ">
                    <div className="login_card">
                      <div className="login_card_step_content_holder">
                        {/* LOGO */}
                        <Link to="/">
                          <div className="logo_box mb-4">
                            <img
                              src="/assets/images/login-page/login-logo.png"
                              alt="logo"
                              className="login_img"
                            />
                          </div>
                        </Link>

                        <h3 className="welcome_title">School Registration</h3>
                        <p className="choose_text">
                          (All information is required)
                        </p>

                        <Link to="/">
                          <button className="back_btn">
                            <i className="fa-solid fa-arrow-left"></i> Back
                          </button>
                        </Link>

                        <div className="hotel-progress-wrapper">
                          <ProgressBar
                            now={(step / 5) * 100}
                            className="hotel-progress"
                          />
                          <span className="progress-steps-text">
                            {step} / 5
                          </span>
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)}>
                          {/* STEP A */}
                          {step === 1 && (
                            <>
                              <CollageRegistration_step_1
                                register={register}
                                errors={errors}
                                setValue={setValue}
                              />
                            </>
                          )}

                          {/* STEP B */}
                          {step === 2 && (
                            <>
                              <CollageRegistration_step_2
                                register={register}
                                errors={errors}
                                control={control}
                                getValues={getValues}
                              />
                            </>
                          )}

                          {/* STEP C */}
                          {step === 3 && (
                            <>
                              <CollageRegistration_step_3
                                register={register}
                                errors={errors}
                                getValues={getValues}
                                setValue={setValue}
                                watch={watch}
                              />
                            </>
                          )}

                          {/* STEP D */}
                          {step === 4 && (
                            <>
                              <CollageRegistration_step_4
                                register={register}
                                errors={errors}
                              />
                            </>
                          )}

                          {/* STEP E */}
                          {step === 5 && (
                            <>
                              <CollageRegistration_step_5
                                register={register}
                                errors={errors}
                              />
                            </>
                          )}

                          {/* BUTTONS */}
                          <div className="btn-group">
                            {step > 1 && (
                              <Blue_border_button
                                button_text="Back"
                                onClick={() => setStep(step - 1)}
                              />
                            )}

                            <Blue_btn
                              btn_text={step === 5 ? "Submit" : "Next"}
                              type="submit"
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollageRegistration;
